import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { IIsInconsistencyPayload } from '../../models'

export const isInconsistency =
  (data: IRevenue[]) =>
  ({ fn }: IIsInconsistencyPayload) => {
    return fn(data)
  }
